export enum ActivePanel {
    Estimate,
    Costbook
}




// WEBPACK FOOTER //
// ./ClientApp/services/state/activePanel.ts